"use strict";

angular.module('app').factory('DestinationModel', function($routeParams, $location, $injector, selectedLanguage) {
    function Destination(model) {
        var title = 'Diving in ' + model.title + ' | PADI Travel',
            description = model.shortDescription || 'Learn more about ' + model.title + ', when and where to go, where the best dive sites are and which are the most reliable dive operators.';

        this._model = model;
        this.seo = {
            title: model.metaTitle || title,
            description: model.metaDescription || description,
            image: (model.thumbnails) ? model.thumbnails.BigDestination : null,
            kind: 'place'
        };
    }

    Destination.prototype.info = function() {
        return this._model;
    };

    Destination.prototype.recentlyViewed = function() {
        var recently = $injector.get('RecentlyViewed');
        recently.add({
            item_type: this._model.model,
            item_slug: this._model.slug
        });

        return this;
    };

    Destination.prototype.getHighlight = function(_this) {
        var dest = $injector.get('Destinations');

        dest.getHighlights().then(function(data) {
            _this.info.highlights = data;
        });

        return this;
    };

    Destination.prototype.getClosest = function(_this) {
        var dest = $injector.get('Destinations');

        dest.getClosest().then(function(data) {
            _this.info.closest = data;
        });

        return this;
    };

    Destination.prototype.getArticles = function(_this) {
        var dest = $injector.get('Destinations');

        dest.getArticles().then(function(data) {
            _this.info.articles = data;
        });

        return this;
    };

    Destination.prototype.topDestinationLinks = function(kind) {
        var url,
            parsedKind = parseInt(kind);

        if (parsedKind === 0) {
            url = 'dive-centers';
        } else if (parsedKind === 10) {
            url = 'liveaboards';
        } else if (parsedKind === 20) {
            url = 'dive-resorts';
        } else if (kind === 'Dive sites') {
            url = 'dive-sites';
        }


        var urlMaker = $injector.get('urlMaker');

        $location.path(urlMaker.searchPageUrl({type: url, slug: $routeParams.location}));
    };

    Destination.prototype.generateSeoTags = function() {
        var seo = $injector.get('SeoService');

        seo.generateMetaTags(this.seo.title, this.seo.description, this.seo.image, this.seo.kind);

        return this;
    };

    Destination.prototype.findDO = function(type) {
        var urlMaker = $injector.get('urlMaker'),
            url = urlMaker.searchPageUrl({type: type, slug: this.info.slug});

        $location.path(url);
    };

    return {
        dest: Destination,
        utils: {
            generateUrl: function(slug) {
                if (slug === null) {
                    return '#';
                }
                if (_.isUndefined(slug) || !_.isString(slug)) {
                    window.console.error('Slug should be a string');
                    return '#';
                }

                if (selectedLanguage !== 'en') {
                    return '/' + selectedLanguage + '/d/' + slug + '/';
                }

                return '/d/' + slug + '/';
            }
        }
    };
});